import { render, staticRenderFns } from "./RegularSessionsDashboard.vue?vue&type=template&id=437f8c46"
import script from "./RegularSessionsDashboard.vue?vue&type=script&lang=ts"
export * from "./RegularSessionsDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports